import { VirtusIcon } from '@virtus/components/icons';
import { Route } from '@virtus/components/page/models/route';

const topRightMenuItems = [  
  
];

export default (routes: Route[]) => ({
  routes: {
    name: 'root',
    mainLogo: {
      component: VirtusIcon,
      props: {
        style: {
          width: '100px',
        },
      },
    },
    path: '',
    active: 0,
    subroutes: routes,
  },
  topRightMenuItems,
});
